import ExcelJS from "exceljs";
import ConstantData from "../Utils/Constant";
import { removeKeys } from "./dataHelper";

export const converJsonToExcel = (jsonData , fileName) => { 

        const defaultAlgnment = { vertical: "top", horizontal: "left" };      
        // Create a new workbook
        const wb = new ExcelJS.Workbook();

        // Iterate over the keys in jsonData
        Object.keys(jsonData).forEach((key) => {
          // Remove excluded data based on some condition
          if (ConstantData.excludedData[key]) {
            const keysNeedsToBeDeleted = ConstantData.excludedData[key];
            jsonData[key] = removeKeys(jsonData[key], keysNeedsToBeDeleted);
          }
      
          if (Array.isArray(jsonData[key]) && jsonData[key].length > 0) {
            const formattedList = updateKeyHeader(jsonData[key]);
            const ws = wb.addWorksheet(ConstantData.excelHeader[key]);
      
            // Define headers (assumes at least one item exists in formattedList)
            const headers = Object.keys(formattedList[0]);
            const headerRow = ws.addRow(headers);
      
            // Apply header style (alignment to center, bold font)
            headerRow.eachCell((cell) => {
              cell.alignment = defaultAlgnment;
              cell.font = { bold: true };
            });
      
            // Add data rows with top-left alignment
            formattedList.forEach((rowData) => {
              const row = ws.addRow(Object.values(rowData));
              row.eachCell((cell) => {
                cell.alignment = defaultAlgnment;
              });
            });
          }
        });
      
        // Write buffer and trigger download
        wb.xlsx.writeBuffer()
          .then((buffer) => {
            const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `${fileName}.xlsx`;
            link.click();
          })
          .catch((err) => {
            console.error("Error generating the Excel file:", err);
          });
}

const updateKeyHeader = (arr) => {

    // Function to update keys based on the keyMapping object
    arr = arr.map(obj => {
      let updatedObj = {};
      for (let key in obj) {
        if (ConstantData.excelRowHeader[key]) {
          updatedObj[ConstantData.excelRowHeader[key]] = obj[key]; // Set new key
        } else {
          updatedObj[key] = obj[key]; // Keep original key if not in mapping
        }
      }
      return updatedObj;
    });

    return arr;
  }